exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.split-line[data-v-3a8d0e0f]{\r\n  height: 1px;\r\n  margin: 5px 0;\r\n  border-bottom: 1px solid #e6eaea;\n}\r\n", ""]);

// exports
